import { HttpClient } from '@angular/common/http';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { environment } from '../../../environments';


@Component({
    selector: 'app-privacy-and-terms',
    imports: [],
    templateUrl: './privacy-and-terms.component.html',
    styleUrl: './privacy-and-terms.component.scss',
    encapsulation: ViewEncapsulation.ShadowDom
})
export class PrivacyAndTermsComponent {

  @Input() htmlFileName: string = '';
  displayHTML: SafeHtml | null = null;
  message = '';
  isLoading = true;

  constructor(private sanitizer: DomSanitizer, private http: HttpClient) { }


  ngOnInit() {
    this.isLoading = true;
    this.http.get(`${environment.landingPageUrl}${this.htmlFileName}`, { responseType: 'text' })
      .subscribe({
        next: (htmlString) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlString, 'text/html');
          const desiredDiv = doc.querySelector('.pricing-box.legal-content');

          if (desiredDiv && desiredDiv.innerHTML.trim()) {
            this.displayHTML = this.sanitizer.bypassSecurityTrustHtml(desiredDiv.innerHTML);
          } else {
            this.message = 'Content is not available at the moment.';
          }
          this.isLoading = false;
        },
        error: () => {
          this.message = 'Failed to load privacy policy.';
          this.isLoading = false;
        }
      });
  }

}
